var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group-append char-counter",class:{ danger: _vm.size <= 10 }},[_c('span',{staticClass:"input-group-text",attrs:{"id":"basic-addon2"}},[_vm._v(_vm._s(_vm.size))])])
}
var staticRenderFns = []

export { render, staticRenderFns }